import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getBestContrastColor } from '../../common/color.helper';
import { formatPercent } from '../../common/formatHelper';
import useFormatter from '../../common/useFormatter';
import useGetNamedColor from '../../common/useGetNamedColor';
import GenericMetricChart, {
  ChartDataItem,
} from '../../components/charts/GenericMetricChart';
import { Stat } from '../../components/stats/Stat';
import { StatListItem } from '../../components/stats/StatListItem';
import {
  ActualityAggregatedHqExtendedDataRow,
  ActualityAggregatedHqExtendedStatsDataColumn,
} from '../store/actuality.kpi.types';
import { getActualityAggregationMetricDescriptorsMap } from '../store/feedMetrics';

export type ActualityAggregatedStatsMetricPieChartProps = {
  title: string;
  subTitle?: string;
  row: ActualityAggregatedHqExtendedDataRow;
  metrics: ActualityAggregatedHqExtendedStatsDataColumn[];
  metricGroups: {
    title: string;
    metrics: ActualityAggregatedHqExtendedStatsDataColumn[];
  }[];
  cardView?: boolean;
  switchUnitOfMeasure?: React.ReactNode;
  showAsPercentage?: boolean;
};

const ActualityAggregatedStatsMetricPieChart: React.FC<
  ActualityAggregatedStatsMetricPieChartProps
> = props => {
  const { t } = useTranslation('feed');
  const formatter = useFormatter();
  const getNamedColor = useGetNamedColor();
  const metricDescriptorsMap = getActualityAggregationMetricDescriptorsMap(
    t,
    formatter,
  );
  console.log(
    'ActualityAggregatedStatsMetricPieChart  metricDescriptorsMap',
    metricDescriptorsMap,
  );

  const total = _.sumBy(props.metrics, m => props.row[m] ?? 0);

  const chartData: ChartDataItem[] = _.map(props.metrics, metric => {
    const metricDescriptor = metricDescriptorsMap[metric];
    const value = props.row[metric] as number;

    console.log(
      'ActualityAggregatedStatsMetricPieChart  metricDescriptor',
      metricDescriptor,
    );

    console.log('ActualityAggregatedStatsMetricPieChart  metric', metric);

    // console.log(
    //   'ActualityAggregatedStatsMetricPieChart  getNamedColor',
    //   getNamedColor(String(metric))[0],
    //   getNamedColor(String(metric))[1],
    // );

    return {
      id: String(metricDescriptor),
      value,
      label: metricDescriptor.title,
      color: [
        getNamedColor(String(metric))[0],
        getBestContrastColor(getNamedColor(String(metric))[0]),
      ],
      formatted: props.showAsPercentage
        ? formatter.formatShare(total > 0 ? value / total : 0)
        : metricDescriptor.getFormatted(value),
    };
  });

  return (
    <Stat
      title={props.switchUnitOfMeasure ? ' ' : props.title}
      // dashboardSimulationView={props.dashboardSimulationView}
      // cardView={props.cardView}
      className={'w-full'}
      hasHelper
      isPreview
      inPanelMode
      switchUnitOfMeasure={props.switchUnitOfMeasure}
    >
      <GenericMetricChart
        data={chartData}
        // metricDescriptor={undefined}
        // showChartTypeSelector={  true}

        showChartTypeSelector={false}
        containerHeight={300}
        showCenterPie={true}
        centerPieStat={
          <div className="absolute top-0 isolate flex h-full w-full flex-1 flex-col items-center justify-center text-center ltr:left-0 rtl:right-0">
            {_.map(props.metricGroups, (group, index) => {
              const groupValue = _.sumBy(group.metrics, m => props.row[m] ?? 0);
              const value = total > 0 ? groupValue / total : 0;
              return (
                <React.Fragment key={`global-event-group-${group.title}`}>
                  {index > 0 && (
                    <hr className="border-menu-300 my-2 w-28 border border-opacity-20 xl:w-32" />
                  )}
                  <div className="">
                    <div className="text-minimal lg:text-xxs uppercase">
                      {group.title}
                    </div>
                    <div className="text-sm lg:text-2xl">
                      {formatPercent(value)}
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        }
      />
      {/* <ContainerChart>
        <div className="absolute top-0 isolate flex h-full w-full flex-1 flex-col items-center justify-center text-center ltr:left-0 rtl:right-0">
          {_.map(props.metricGroups, (group, index) => {
            const groupValue = _.sumBy(group.metrics, m => props.row[m] ?? 0);
            const value = total > 0 ? groupValue / total : 0;
            return (
              <React.Fragment key={`global-event-group-${group.title}`}>
                {index > 0 && (
                  <hr className="border-menu-300 my-2 w-28 border border-opacity-20 xl:w-32" />
                )}
                <div className="">
                  <div className="text-minimal lg:text-xxs uppercase">
                    {group.title}
                  </div>
                  <div className="text-xl lg:text-2xl">
                    {formatPercent(value)}
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
        <SimulationPieChart data={chartData} />
      </ContainerChart> */}
      {_.map(chartData, metric => {
        if (!metric.value || metric.value <= 0) {
          return null;
        }

        return (
          <StatListItem
            key={`event-type-group-label-${metric.id}`}
            title={metric.label}
            value={metric.formatted.value}
            legendColor={metric.color[0]}
            legendType="circle"
            unitOfMeasure={metric.formatted.unit}
          />
        );
      })}
    </Stat>
  );
};

export default ActualityAggregatedStatsMetricPieChart;
